import { render, staticRenderFns } from "./InventarioDetallado.vue?vue&type=template&id=95341c4a&scoped=true"
import script from "./InventarioDetallado.vue?vue&type=script&lang=js"
export * from "./InventarioDetallado.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InventarioDetallado.vue?vue&type=style&index=1&id=95341c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95341c4a",
  null
  
)

export default component.exports